import { ReactElement } from "react";
import { Typography, Skeleton } from "@mui/material";
import logoLight from "../assets/logo-optimus-dark.png";

const SkeletonApp = (): ReactElement => {

  const layout = {
    display: "grid",
    height: "100dvh",
    gridTemplateColumns: "1fr",
    gridTemplateRows: "auto 1fr auto",
    gridRowGap: "15px"
  };


  return (
    <div style={layout}>
      <Skeleton variant="rectangular" height={60} sx={{ gridColumn: "1 / 1", gridRow: "1 / span 1" }}/>

      <Skeleton variant="rectangular" sx={{
        height: "calc(100% - 20px)",
        width: "calc(100% - 20px)",
        gridColumn: "1 / span 1",
        gridRow: "2 / span 1",
        margin: "10px",
      }}/>

      <div style={{
        color: "rgba(0, 0, 0, 0.3)",
        textAlign: "center",
        alignSelf: "center",
        gridColumn: "1 / span 1",
        gridRow: "2 / span 1",
      }}>
        <img src={logoLight} alt={"optimus-steel-logo"} style={{ maxHeight: "180px", margin: "1em" }}/>
        <Typography variant="h6" >
          Loading
        </Typography>
      </div>

      <Skeleton variant="rectangular" height={60} sx={{ gridColumn: "1 / span 1", gridRow: "3 / span 1" }}/>
    </div>
  );
};

export default SkeletonApp;
